import React, { Component } from "react";
import PropTypes from "prop-types";
import { Provider } from "react-redux";
import { Helmet } from "react-helmet";

// ELEMENTS
import Container from "../../ui/src/ui/components/container";
import Content from "../../ui/src/ui/components/content";

// COMPONENTS
import GlobalMenu from "../../components/GlobalMenu";
// import FooterMenu from "../../components/FooterMenu";
import { ToastContainer } from "../../ui";

// PAGES
import RouterPages from "../../routes/router";

const description = "Система управления ломбардами";

class Root extends Component {
  render() {
    const { store } = this.props;

    return (
      <Provider store={store}>
        <Container fluid flex padding="no" className="h-100">
          <Helmet defaultTitle="Malond" titleTemplate="%s | Malond">
            <meta charSet="utf-8" />
            <meta name="description" content={description} />
          </Helmet>

          <ToastContainer />

          <GlobalMenu history={this.props.history} />

          <Content>
            <RouterPages />

            {/* <FooterMenu /> */}
          </Content>
        </Container>
      </Provider>
    );
  }
}

Root.propTypes = {
  store: PropTypes.object.isRequired
};

export default Root;
